import { InjectionToken } from '@angular/core';
import { Platform } from '@bca-core/models/_enums';

/**
 * @description production | acceptation | test | development
 */
export const BCA_PLATFORM = new InjectionToken<Platform>('BCA_PLATFORM');
